import { combineReducers } from 'redux';
import accounts from './accounts';
import locations from './locations';

import suppliers from './suppliers';
import taxSettings from './taxSettings';
import paymentTerms from './paymentTerms';
import paymentMethods from './paymentMethods';
import categories from './categories';
import products from './products';
import assignments from './assignments';
import purchaseOrders from './purchaseOrders';
import incompleteOrders from './incompleteOrders';
import purchaseOrderLines from './purchaseOrderLines';
import receivingOrders from './receivingOrders';
import settings from './settings';
import thresholds from './thresholds';
import suggestedPurchaseOrders from './suggestedPurchaseOrders';

export default combineReducers({
  accounts,
  incompleteOrders,
  locations,
  suppliers,
  taxSettings,
  paymentTerms,
  paymentMethods,
  categories,
  products,
  assignments,
  purchaseOrders,
  purchaseOrderLines,
  receivingOrders,
  settings,
  thresholds,
  suggestedPurchaseOrders,
});